<script>
    import VcPaginacao from "@/components/Form/Paginacao";
    import VcBotoesListagemAnalise from "./BotoesListagem";
    import VcDetalhesAnalise from "./DetalhesAnalise"
    import bus from "../../bus";

    export default {
        components: {
            VcPaginacao,
            VcBotoesListagemAnalise,
            VcDetalhesAnalise
        },
        data() {
            return {
                analises: {},
                analisesPendentes: {},
                pagination: {},
                paginationPendentes: {},
                analisesSite: {},
                analisesApp: {},
                analisesExternas: {},
                podeCriarPagamento: false,
                valorAnalisesExterna: 0,
                paginationSite: {},
                paginationExternas: {},
                termo: "",
                remetentesData: [],
                filtro: null,
                modalKey: 0,
                order: "ASC",
                campo: "registro",
                porPagina: {label: "25", value: "25"},
                tipo: {label: "Todos", value: "TODOS"},
                cultura: {label: "Todas", value: "TODAS"},
                optionsTipo: [
                    {label: 'Todas', value: 'TODOS'},
                    {label: 'Solos', value: 'SOLO'},
                    {label: 'Sementes', value: 'SEMENTE'},
                    {label: 'Tecidos vegetais', value: 'TECIDO'},
                    {label: 'Fertilizantes', value: 'FERTILIZANTE'},
                ],
                analiseSelecionada: {},
                formaPagamentoApp: {label: 'Vista', value: 'FATURADA'},
                fisicaApp: {label: 'Não', value: false},
                remetenteApp: null,
            };
        },

        watch: {
            tipo() {
                this.navigate(1);
            },
            porPagina() {
                this.navigate(1);
            },
            filtro() {
                this.navigate(1);
            }
        },

        computed: {
            gerente() {
                return (parseInt(this.$store.state.Auth.user.permissao_empresa.gerente) || parseInt(this.$store.state.Auth.user.permissao_empresa.master))
            },

            consultaAnalise() {
                return this.$store.state.Auth.user != null && this.$store.state.Auth.user.permissao_empresa != null && parseInt(this.$store.state.Auth.user.permissao_empresa.venda_manter)
            },

            celular( ){
                return window.innerWidth < 400 ? true : false
            }
        },

        methods: {
            mostraModalBotoes(analise) {
                this.$set(this, 'analiseSelecionada', analise)
            },
            navigate(pagina) {
                // setTimeout(() => {
                //     swal.showLoading();
                // }, 10);
                this.$http.post("api/analises/listagem?page=" + pagina, {
                    termo: this.termo,
                    campo: this.campo,
                    ordem: this.order,
                    porPg: this.porPagina.value,
                    tipo: this.tipo.value
                })
                    .then(response => {
                        this.analises = response.data.analises.original.data;
                        this.pagination = response.data.analises.original;

                        this.analisesPendentes = response.data.analisesPendentes.original.data;
                        this.paginationPendentes = response.data.analisesPendentes.original;

                        this.analisesSite = response.data.analisesSite.original.data;
                        this.paginationSite = response.data.analisesSite.original;
                        this.analisesApp = response.data.analisesApp.original;
                        this.analisesExternas = response.data.analisesExternas.original;
                        this.paginationExternas = response.data.analisesExternas.original;
                    }).then(() => {
                        // setTimeout(() => {
                        //     swal.close();
                        // }, 1000);
                    });
            },

            async pagarEstornarAnalisePrazo(index, pendentes) {
                let analise = pendentes ? this.analisesPendentes[index] : this.analises[index]

                let titulo = "Marcar como paga"
                let pergunta = "Deseja marcar como paga a análise "
                let conclusao = "Pagamento realizado com sucesso."
                let url = "api/analises/vincula-informacao-pedido"
                if (parseInt(analise.faturado)) {
                    titulo = "Estornar pagamento"
                    pergunta = "Deseja estornar o pagamento da análise "
                    conclusao = "Estorno realizado com sucesso."
                    url = 'api/analises/estorna-analise/' + analise.id
                }

                window.swal({
                    title: titulo,
                    text: pergunta + analise.registro + " / " + analise.ano_registro + "?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não"
                }).then(async result => {
                    if (result.value) {
                        this.$http.post(url, {'analises': {0: analise.id}, 'pedido': null}).then(response => {
                            window.swal("Sucesso!", conclusao, "success")
                            this.navigate(1)
                        }).catch(error => {
                            return window.swal("Atenção", "Houve um problema . <br><br>" + error.response.data.message, "warning");
                        });
                    }
                });
            },

            async liberarAnaliseSebrae(index) {
                let analise = this.analises[index]

                window.swal({
                    title: "Liberar análise Sebrae",
                    text: "Deseja marcar como liberada a análise?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não"
                }).then(async result => {
                    if (result.value) {
                        this.$http.post("api/analises/liberar-analise-sebrae", {'id': analise.id}).then(response => {
                            window.swal("Sucesso!", "Análise liberada com sucesso.", "success")
                            this.navigate(1)
                        }).catch(error => {
                            return window.swal("Atenção", "Houve um problema . <br><br>" + error.response.data.message, "warning");
                        });
                    }
                });
            },

            abreDetalhes(index, pendentes, site) {
                let valor = true
                if (pendentes && !site) {
                    valor = this.analisesPendentes[index].detalhe == undefined ? true : !this.analisesPendentes[index].detalhe
                    this.$set(this.analisesPendentes[index], 'detalhe', valor)
                } else if (!pendentes && site) {
                    valor = this.analisesSite[index].detalhe == undefined ? true : !this.analisesSite[index].detalhe
                    this.$set(this.analisesSite[index], 'detalhe', valor)
                } else {
                    valor = this.analises[index].detalhe == undefined ? true : !this.analises[index].detalhe
                    this.$set(this.analises[index], 'detalhe', valor)
                }
            },

            abreLog(index, pendentes) {
                let valor = true
                if (pendentes) {
                    valor = this.analisesPendentes[index].log == undefined ? true : !this.analisesPendentes[index].log
                    this.$set(this.analisesPendentes[index], 'log', valor)
                } else {
                    valor = this.analises[index].log == undefined ? true : !this.analises[index].log
                    this.$set(this.analises[index], 'log', valor)
                }
            },

            enviarEmail(index, pendentes = false) {
                let analise
                if (pendentes) {
                    analise = this.analisesPendentes[index]
                    this.$set(this.analisesPendentes[index], 'enviou', true)
                } else {
                    analise = this.analises[index]
                    this.$set(this.analises[index], 'enviou', true)
                }

                window.swal({
                    title: "Enviando e-mail",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        this.$http.post("api/analises/mail/" + analise.id)
                            .then(response => {
                                if (parseInt(response.data.enviado)) {
                                    if (response.data.mensagem.length != undefined) {
                                        return window.swal("Sucesso", response.data.mensagem, "success");
                                    }
                                    return window.swal("Sucesso", "E-mail enviado com sucesso.", "success");
                                }
                                throw new Error(response.data.mensagem)
                            }).catch(error => {
                            return window.swal("Atenção", "Houve um problema ao enviar e-mail . <br><br>" + error.response.data.message, "warning");
                        });
                    }
                });
            },

            selecionarAnaliseCriarPagamento(indexAnalise) {
                this.$set(this.analisesExternas.data[indexAnalise], 'selecionadaPagamento', this.analisesExternas.data[indexAnalise].selecionadaPagamento != undefined ? !this.analisesExternas.data[indexAnalise].selecionadaPagamento : true)
                let self = this;
                let podeCriarPag = false;

                this.analisesExternas.data.forEach(element => {
                    if(element.selecionadaPagamento != undefined && element.selecionadaPagamento == true){
                        podeCriarPag = true;
                    }
                });

                self.podeCriarPagamento = podeCriarPag;
            },

            confirmaPagamentoExterna(){
                let analisesPagar = [];
                let self = this;
                this.analisesExternas.data.forEach(element => {
                    if(element.selecionadaPagamento != undefined && element.selecionadaPagamento == true){
                        analisesPagar.push(element.id)
                    }
                });

                window.swal({
                    title: "Gerando dados para pagamento",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        this.$http.post("api/analises/criarPagamentoAnalisesExternas/", {analises: analisesPagar, valor: this.valorAnalisesExterna})
                            .then(response => {
                                if(response.data.dados.pixCopiaCola == undefined ){
                                        return window.swal("Houve um erro ao gerar o QR-Code", response.data.dados, "error");
                                } else {
                                    let dados = response.data.dados;
                                    window.swal({
                                        title: "QR-code criado com sucesso",
                                        html: `<p><strong>Pix copia e cola:</strong> ${dados.pixCopiaCola}</p>
                                               <img src="${dados.qr64encoded}" alt="QR Code Pix" style="margin-top: 15px; width: 200px; height: 200px;" />
                                               <p><strong>QR-Code também se encontra disponível no LABCS.</strong></p>
                                               <button id="copyButton" class="btn btn-info" style="margin-top:10px;">Copiar código PIX</button>`,
                                        focusConfirm: false,
                                        confirmButtonText: 'Fechar',
                                    });
                                    document.addEventListener('click', function(event) {
                                        if (event.target && event.target.id === 'copyButton') {
                                            navigator.clipboard.writeText(dados.pixCopiaCola);
                                            $("#copyButton").removeClass('btn-info');
                                            $("#copyButton").addClass('btn-success');
                                            document.getElementById('copyButton').innerText = 'Copiado!';
                                            document.getElementById('copyMessage').innerText = 'Copiado para a área de transferência.';
                                        }
                                    });
                                    self.abrirModalCriarPagamento();
                                    self.podeCriarPagamento = false;
                                    self.navigate(1);
                                }
                            }).catch(error => {
                                console.log(error)
                                return window.swal("Houve um erro ao gerar o QR-Code", 'Tente novamente mais tarde', "error");
                        });
                    }
                });
            },

            abrirFecharDetalhesApp(index){
                if(this.analisesApp.dados[index].dados.detalhes != undefined){
                    this.$set(this.analisesApp.dados[index].dados, 'detalhes', !this.analisesApp.dados[index].dados.detalhes)
                } else {
                    this.$set(this.analisesApp.dados[index].dados, 'detalhes', true)
                }
            },

            abrirModalCriarPagamento(){
                $('#modal-pagamento-externas').modal('toggle');
            },

            buscaRemetentes(){
                let remetentes = [];
                this.$http.post("api/buscaRemetentes").then(response => {
                    response.data.forEach(remetente => {
                        remetentes.push({label: (remetente.nome != null ? remetente.nome : remetente.razao_social) , value: remetente.id})
                    });
                });

                this.$set(this, 'remetentesData', remetentes);
            },

            aceitarApp(index){
                let self = this;
                window.swal({
                    title: "Confirmação",
                    text: "Deseja realmente aceitar a operação selecionada?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não"
                })
                .then(result => {
                    if(result.value){
                        self.appIndexSelecionada = index;
                        $('#modal-forma-pag-aceite').modal('toggle')
                    }
                })
            },

            confirmaResultadoApp(){
                $('#btnConfirmaResultadoApp').prop('disabled', true);
                let self = this;
                if(self.remetenteApp == null){
                    window.swal("Atenção", "Selecione o remetente!", "warning");
                    $('#btnConfirmaResultadoApp').prop('disabled', false);
                    return;
                }
                this.$http.post("/api/analises/recebeDadoAceitarApp", {id: self.analisesApp.dados[self.appIndexSelecionada].id_banco, forma_pagamento: self.formaPagamentoApp.value, remetente_id: self.remetenteApp.value, fisica: self.fisicaApp.value}).then(response => {
                    if(response.data.erro == '1'){
                        window.swal("Erro", response.data.mensagem, "error");
                    } else {
                        window.swal("Sucesso", "Os dados foram inseridos no sistema com sucesso!", "success");
                    }
                    $('#modal-forma-pag-aceite').modal('toggle')
                    self.navigate(1);
                    self.remetenteApp = null;
                    $('#btnConfirmaResultadoApp').prop('disabled', false);
                });

            },

            rejeitarApp(index){
                let self = this;
                window.swal({
                    title: "Confirmar exclusão",
                    text: "Deseja realmente remover a opção selecionada?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não"
                })
                .then(result => {
                    if(result.value){
                        this.$http.post("/api/analises/recebeDadoRejeitarApp", {id: self.analisesApp.dados[index].id_banco}).then(response => {
                        window.swal("Sucesso", "Dados removidos da listagem com sucesso!", "success");
                        self.navigate(1);
                    });
                    }
                })
            },

            sincronizaPagamentos() {
                window.swal({
                    title: "Sincronizando pagamentos",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        this.$http.post("api/analises/sincronizaPagamento").then(response => {
                            window.swal("Sucesso", "Pagamentos sincronizados com sucesso!", "success")
                        });
                    }
                });
            },

            ordenar(campo) {
                this.$set(this, "campo", campo);
                if (this.order === "ASC") {
                    this.order = "DESC";
                } else {
                    this.order = "ASC";
                }
                this.navigate(1);
            },

            digitarResultado(analise) {
                this.$store.dispatch("setModel", analise);
                this.$router.push({name: "analises.resultado"});
            },

            buscaAnalises() {
                this.analiseSelecionada = {}
                this.navigate(1)
            },

            editarAnaliseSite(analise) {
                this.$http.post("api/analises/verifica-cadastro-pessoas/" + analise.id).then(() => this.$router.push({name: "analises.editar", params: {id: analise.id}}))
            },

            remover(analise) {
                window.swal({
                    title: "Remover registro?",
                    text: "Deseja realmente remover a análise selecionada?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não"
                })
                    .then(result => {
                        if (result.value) {
                            this.$http.delete("api/analises/" + analise.id).then(() => {
                                this.navigate(1);
                                return window.swal("Sucesso", "Análise removida com sucesso.", "success");
                            }).catch(error => {
                                return window.swal("Atenção", "Houve um problema ao remover a análise. <br><br>" + error.response.data.message, "warning");
                            });
                        }
                    });
            },

            downloadArquivoFoto(analise) {
                this.$http.post("api/analises/download-foto/" + analise.id).then(response => {
                    if (response.data.arquivo == null) {
                        return window.swal(
                            "Atenção",
                            "Houve um problema ao realizar download.<br><br>" +
                            response.data.mensagem,
                            "warning"
                        );
                    }
                    let a = document.createElement("a");
                    a.href = "data:application/octet-stream;base64," + response.data.arquivo;
                    a.download = analise.solo.caminho_foto.replace(analise.empresa_id + '/solos', '');
                    a.click();
                });
            },

            abrirModal(analise) {
                this.analiseSelecionada = {};
                this.$nextTick(() => {
                    this.analiseSelecionada = { ...analise };
                    this.modalKey++;
                });
            },

            fecharModal() {
                this.$nextTick(() => {
                    this.analiseSelecionada = {};
                });
            }
        },

        mounted() {
            const self = this
            this.navigate(1);
            this.$store.dispatch("setTitle", "Análises");

            if (this.$route.params.analiseEditar != undefined) {
                this.$router.push({name: "analises.editar", params: {id: this.$route.params.analiseEditar}})
            }

            if (this.$route.params.GUIA != undefined && this.$route.params.GUIA == 'PENDENTES') {
                $('#naoDigitadas').addClass('in active')
                $('#guiaSolosPendentes').addClass('active')
            } else {
                $('#todas').addClass('in active')
                $('#guiaTodas').addClass('active')
            }

            if (this.$route.params.TIPO != undefined) {
                let tipoSelect = this.$route.params.TIPO
                let optionSelect = this.optionsTipo.filter(option => { if (tipoSelect == option.value) return option })[0]
                setTimeout(function () {
                    $('#selectTipoAnalise').val(tipoSelect).trigger('change')
                    self.$set(self, 'tipo', optionSelect)
                }, 200)
            }

            $('#guiaSementesPendentes').on('click', () => {
                $('#selectTipoAnalise').val('SEMENTE').trigger('change.select2')
                self.tipo = 'SEMENTE'
                self.$set(self, 'tipo', {label: 'Sementes', value: 'SEMENTE'})
                self.navigate(1)
            })

            $('#guiaSolosPendentes').on('click', () => {
                $('#selectTipoAnalise').val('SOLO').trigger('change.select2')
                self.tipo = 'SOLO'
                self.$set(self, 'tipo', {label: 'Solos', value: 'SOLO'})
                self.navigate(1)
            })

            $('#guiaApp').on('click', () => {
                $('#gradeApp').addClass('in active')
                $('#guiaApp').addClass('active')

                $('#naoDigitadas').removeClass('in active')
                $('#todas').removeClass('in active')
                $('#site').removeClass('in active')

                $('#guiaSolosPendentes').removeClass('active')
                $('#guiaSementesPendentes').removeClass('active')
                $('#guiaTodas').removeClass('active')
                $('#guiaSite').removeClass('active')
                $('#guiaExternas').removeClass('active')
                $('#gradeExternas').removeClass('active')
            })

            $('#guiaExternas').on('click', () => {
                $('#gradeExternas').addClass('in active')
                $('#gradeApp').addClass('active')
                $('#guiaSolosPendentes').removeClass('active')
                $('#guiaSementesPendentes').removeClass('active')
                $('#guiaTodas').removeClass('active')
                $('#guiaApp').removeClass('active')
                $('#guiaSite').removeClass('active')
                $('#naoDigitadas').removeClass('in active')
                $('#todas').removeClass('in active')
                $('#site').removeClass('in active')
            })

            bus.$on('atualizarListagemAnalises', () =>{
                self.buscaAnalises();
            })

            this.buscaRemetentes();
        }
    };

</script>

<template>
    <div class="margin-top-10">

        <div v-if="consultaAnalise">
            <div class="col-xs-12 col-sm-12">
                <div class="form-group">
                    <router-link :to="{name: 'analises.adicionar'}" class="btn btn-success">Adicionar</router-link>
                    &nbsp;
                    <button type="button" class="btn btn-info" @click="sincronizaPagamentos">Sincronizar pagamentos
                    </button>
                </div>
            </div>
            <br>
            <br>
        </div>
        <div>
            <vc-botoes-listagem-analise
                :key="modalKey"
                :analise-prop="analiseSelecionada"
                :navigate="navigate"
                v-if="typeof analiseSelecionada.id !== 'undefined'"
                @close="fecharModal"
            />
        </div>

        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-4">
                        <label>Registros por página</label>
                        <v-select
                                v-model="porPagina"
                                :options="[
                                {label: '10', value: '10'},
                                {label: '25', value: '25'},
                                {label: '50', value: '50'},
                                {label: '100', value: '100'},
                            ]"
                        ></v-select>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group">
                            <label>Tipo</label>
                            <v-select
                                    id="selectTipoAnalise"
                                    v-model="tipo"
                                    :options="optionsTipo"
                            ></v-select>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-4 pull-right">
                        <div class="form-group">
                            <label>&nbsp;</label>
                            <input type="text" v-model="termo" class="form-control" @keyup.enter="navigate(1)" placeholder="Pesquisar">
                        </div>
                    </div>
                </div>

                <ul class="nav nav-tabs">
                    <li id="guiaTodas"><a data-toggle="tab" href="#todas">Todas as análises</a></li>
                    <li id="guiaSementesPendentes"><a data-toggle="tab" href="#naoDigitadas">Resultados de sementes pendentes</a></li>
                    <li id="guiaSolosPendentes"><a data-toggle="tab" href="#naoDigitadas">Resultados de solos pendentes</a></li>
                    <li id="guiaSite"><a data-toggle="tab" href="#site">Análises site {{ paginationSite.total != 0 ? ( '(' + paginationSite.total + ')' ) : '' }}</a></li>
                    <li id="guiaApp"><a data-toggle="tab" href="#gradeApp">APP ({{ analisesApp.dados != undefined ? analisesApp.dados.length : 0}}) - ({{ analisesApp.qtdColeta }})</a></li>
                    <li id="guiaExternas"><a data-toggle="tab" href="#gradeExternas">Análises externas ({{ analisesExternas.data != undefined ? analisesExternas.data.length : 0}})</a></li>
                </ul>
                <div class="tab-content">
                    <div id="todas" class="tab-pane fade">
                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table dataTable">
                                    <thead>
                                    <tr role="row">
                                        <th width="19%">Produtor / Proprietário</th>
                                        <th width="19%">Proprietário / Cedente</th>
                                        <th width="15%">Remetente</th>
                                        <th width="8%" @click="ordenar('tipo')">Tipo</th>
                                        <th width="8%" @click="ordenar('registro')">Registro</th>
                                        <th width="8%">Resultado</th>
                                        <th width="8%" @click="ordenar('valor_amostra')" class="text-center">Valor
                                            (R$)
                                        </th>
                                        <th width="16%" class="text-center">Ações</th>
                                    </tr>
                                    </thead>
                                    <tbody :key="indexAnalise" v-for="(analise, indexAnalise) in analises">
                                    <tr role="row" class="even"
                                        :class="{
                                            'nao-paga': !analise.faturado * 1 && analise.forma_pagamento != 'FATURADA' ,
                                            'nao-paga-boleto': analise.data_pagamento == null && analise.forma_pagamento == 'BOLETO' && analise.pedido_id != null ,
                                            'subsidio-sebrae': analise.subsidio_sebrae == 1
                                        }">
                                        <td>
                                            <div :key="index" v-for="(proprietario, index) in analise.proprietarios"
                                                 style="margin-bottom: 7px;">
                                                <span v-if="proprietario.tipo == 1">{{ proprietario.nome }}<br>{{ proprietario.cpf }}</span>
                                                <span v-else>{{ proprietario.razao_social }}<br>{{ proprietario.cnpj }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div :key="index" v-for="(arrendatario, index) in analise.arrendatarios"
                                                 style="margin-bottom: 7px;">
                                                <span v-if="arrendatario.tipo == 1">{{ arrendatario.nome }}<br>{{ arrendatario.cpf }}</span>
                                                <span v-else>{{ arrendatario.razao_social }}<br>{{ arrendatario.cnpj }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div style="margin-bottom: 7px;" v-if="analise.remetente !== null">
                                                <span v-if="analise.remetente.tipo == 1">{{ analise.remetente.nome }}<br>{{ analise.remetente.cpf }}</span>
                                                <span v-else>{{ analise.remetente.razao_social }}<br>{{ analise.remetente.cnpj }}</span>
                                            </div>
                                        </td>
                                        <td>{{analise.tipo}}</td>
                                        <td>{{analise.registro }}/{{ analise.ano_registro }}<br>{{
                                            analise.forma_pagamento == "BOLETO" ? 'Boleto' + (analise.emitir_nota == '1'
                                            ? ' (NFS-e)' : '') :
                                            (
                                            analise.forma_pagamento == "FATURADA" && analise.data_pagamento ==
                                            analise.data_registro ? 'À vista' + (analise.emitir_nota == '1' ? ' (NFS-e)'
                                            : '') :
                                            (
                                            analise.forma_pagamento == "NFATURAR" && analise.faturado == '0' ? 'À prazo'
                                            + (analise.emitir_nota == '1' ? ' (NFS-e)' : '') :
                                            (
                                            (analise.forma_pagamento == "FATURADA" && analise.data_pagamento != null && analise.data_pagamento !=
                                            analise.data_registro) ||
                                            (analise.forma_pagamento == "NFATURAR" && analise.data_pagamento != null && analise.data_pagamento !=
                                            analise.data_registro && analise.faturado == '1')
                                            ? 'Pago' + (analise.emitir_nota == '1' ? ' (NFS-e)' : '') : ''
                                            )
                                            )
                                            )
                                            }}
                                        </td>
                                        <td>
                                            <div style="margin-bottom: 7px;">
                                                <span v-if="analise.data_resultado_formatada != null">{{ analise.data_resultado_formatada }}</span>
                                            </div>
                                        </td>
                                        <td class="text-center">{{ analise.valor_amostra | formatMoney }}</td>
                                        <td class="text-center lista-analises">

                                            <button :class="{'btn btn-xs btn-success': analise.enviou, 'btn btn-xs btn-info': !analise.enviou}"
                                                    @click="enviarEmail(indexAnalise)"
                                                    title="Enviar por email">
                                                <i class="fa fa-envelope"></i>
                                            </button>

                                            <button type="button" class="btn btn-xs btn-default"
                                                    @click="mostraModalBotoes(analise)">Opções
                                            </button>

                                            <button class="btn btn-xs btn-info"
                                                    @click="abreDetalhes(indexAnalise, false)"
                                                    title="Detalhes"><i
                                                    :class="{'fa fa-plus': !analise.detalhe, 'fa fa-minus': analise.detalhe}"></i>
                                            </button>

                                            <button v-if="consultaAnalise && gerente && analise.subsidio_sebrae == 1"
                                                    class="btn btn-xs"
                                                    :class="{'btn-success': analise.subsidio_sebrae_status == 'PENDENTE', 'btn-info': analise.subsidio_sebrae_status == 'LIBERADA'}"
                                                    :disabled="analise.subsidio_sebrae_status == 'LIBERADA'"
                                                    @click="liberarAnaliseSebrae(indexAnalise)"
                                                    :title="analise.subsidio_sebrae_status == 'PENDENTE' ? 'Marcar como liberada' : 'Análise liberada'">
                                                <i class="fa fa-money-bill"></i>
                                            </button>

                                            <button v-if="consultaAnalise && gerente && analise.subsidio_sebrae == 0"
                                                    class="btn btn-xs"
                                                    :class="{'btn-success': !parseInt(analise.faturado), 'btn-danger': parseInt(analise.faturado)}"
                                                    :disabled="analise.forma_pagamento != 'NFATURAR'"
                                                    @click="pagarEstornarAnalisePrazo(indexAnalise, false)"
                                                    :title="!parseInt(analise.faturado) ? 'Receber análise' : 'Estornar pagamento'">
                                                <i class="fa fa-money-bill"></i>
                                            </button>

                                            <button class="btn btn-xs btn-info"
                                                    :disabled="analise.logs_analise.length == 0"
                                                    @click="abreLog(indexAnalise, false)"
                                                    title="Lista de logs"><i class="fa fa-info-circle"></i>
                                            </button>

                                            <button v-if="consultaAnalise && gerente && analise.subsidio_sebrae == 1"
                                                    class="btn btn-xs"
                                                    :class="{'btn-success': analise.solo.caminho_foto != null, 'btn-info': analise.solo.caminho_foto == null}"
                                                    :disabled="analise.solo.caminho_foto == null"
                                                    @click="downloadArquivoFoto(analise)"
                                                    :title="analise.solo.caminho_foto != null ? 'Atendimento SEBRAE anexado' : 'Sem atendimento SEBRAE'">
                                                <i class="fa fa-paperclip"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="analise.detalhe != undefined && analise.detalhe">
                                        <vc-detalhes-analise :analise-prop="analise" @close="abreDetalhes"
                                                             tipo="DETALHE"/>
                                    </tr>
                                    <tr v-if="analise.log != undefined && analise.log">
                                        <vc-detalhes-analise :analise-prop="analise" @close="abreLog" tipo="LOG"/>
                                    </tr>

                                    <tr v-if="celular">
                                        <th colspan="3">
                                            <div style="margin-bottom: 7px;" v-if="analise.remetente !== null">
                                                <span v-if="analise.remetente.tipo == 1">{{ analise.remetente.nome }}<br>{{ analise.remetente.cpf }}</span>
                                                <span v-else>{{ analise.remetente.razao_social }}<br>{{ analise.remetente.cnpj }}</span>
                                            </div>
                                        </th>
                                    </tr>
                                    </tbody>
                                </table>
                                <vc-paginacao :source="pagination" @navigate="navigate"></vc-paginacao>
                            </div>
                        </div>
                    </div>
                    <div id="naoDigitadas" class="tab-pane fade">
                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table dataTable">
                                    <thead>
                                    <tr role="row">
                                        <th width="19%">Produtor / Proprietário</th>
                                        <th width="19%">Proprietário / Cedente</th>
                                        <th width="15%">Remetente</th>
                                        <th width="10%" @click="ordenar('tipo')">Tipo</th>
                                        <th width="10%" @click="ordenar('registro')">Registro</th>
                                        <th width="8%" @click="ordenar('valor_amostra')" class="text-center">Valor
                                            (R$)
                                        </th>
                                        <th width="19%" class="text-center">Ações</th>
                                    </tr>
                                    </thead>
                                    <tbody :key="indexAnalise" v-for="(analise, indexAnalise) in analisesPendentes">
                                    <tr role="row" class="even"
                                        :class="{
                                            'nao-paga': !analise.faturado * 1 && analise.forma_pagamento != 'FATURADA' ,
                                            'nao-paga-boleto': analise.data_pagamento == null && analise.forma_pagamento == 'BOLETO' && analise.pedido_id != null ,
                                            'subsidio-sebrae': analise.subsidio_sebrae == 1
                                        }">
                                        <td>
                                            <div :key="index" v-for="(proprietario, index) in analise.proprietarios"
                                                 style="margin-bottom: 7px;">
                                                <span v-if="proprietario.tipo == 1">{{ proprietario.nome }}<br>{{ proprietario.cpf }}</span>
                                                <span v-else>{{ proprietario.razao_social }}<br>{{ proprietario.cnpj }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div :key="index" v-for="(arrendatario, index) in analise.arrendatarios"
                                                 style="margin-bottom: 7px;">
                                                <span v-if="arrendatario.tipo == 1">{{ arrendatario.nome }}<br>{{ arrendatario.cpf }}</span>
                                                <span v-else>{{ arrendatario.razao_social }}<br>{{ arrendatario.cnpj }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div style="margin-bottom: 7px;" v-if="analise.remetente !== null">
                                                <span v-if="analise.remetente.tipo == 1">{{ analise.remetente.nome }}<br>{{ analise.remetente.cpf }}</span>
                                                <span v-else>{{ analise.remetente.razao_social }}<br>{{ analise.remetente.cnpj }}</span>
                                            </div>
                                        </td>
                                        <td>{{analise.tipo}}</td>
                                        <td>{{analise.registro }}/{{ analise.ano_registro }}<br>{{
                                            analise.forma_pagamento == "BOLETO" ? 'Boleto' + (analise.emitir_nota == '1'
                                            ? ' (NFS-e)' : '') :
                                            (
                                            analise.forma_pagamento == "FATURADA" && analise.data_pagamento ==
                                            analise.data_registro ? 'À vista' + (analise.emitir_nota == '1' ? ' (NFS-e)'
                                            : '') :
                                            (
                                            analise.forma_pagamento == "NFATURAR" && analise.faturado == '0' ? 'À prazo'
                                            + (analise.emitir_nota == '1' ? ' (NFS-e)' : '') :
                                            (
                                            (analise.forma_pagamento == "FATURADA" && analise.data_pagamento !=
                                            analise.data_registro) ||
                                            (analise.forma_pagamento == "NFATURAR" && analise.data_pagamento !=
                                            analise.data_registro && analise.faturado == '1')
                                            ? 'Pago' + (analise.emitir_nota == '1' ? ' (NFS-e)' : '') : ''
                                            )
                                            )
                                            )
                                            }}
                                        </td>
                                        <td class="text-center">{{ analise.valor_amostra | formatMoney }}</td>
                                        <td class="text-center lista-analises">
                                            <button v-if="consultaAnalise && gerente"
                                                    class="btn btn-xs btn-success" @click="digitarResultado(analise)"
                                                    title="Resultado"><i class="fa fa-check"></i>
                                            </button>

                                            <button :class="{'btn btn-xs btn-info': !analise.enviou, 'btn btn-xs btn-success ': analise.enviou}"
                                                    @click="enviarEmail(indexAnalise, true)"
                                                    title="Enviar email">
                                                <i class="fa fa-envelope"></i>
                                            </button>

                                            <button type="button" class="btn btn-xs btn-default"
                                                    @click="mostraModalBotoes(analise)">Opções
                                            </button>

                                            <button class="btn btn-xs btn-info"
                                                    @click="abreDetalhes(indexAnalise, true)"
                                                    title="Detalhes"><i
                                                    :class="{'fa fa-plus': !analise.detalhe, 'fa fa-minus': analise.detalhe}"></i>
                                            </button>

                                            <button v-if="consultaAnalise && gerente && analise.subsidio_sebrae == 1"
                                                    class="btn btn-xs"
                                                    :class="{'btn-success': analise.subsidio_sebrae_status == 'PENDENTE', 'btn-info': analise.subsidio_sebrae_status == 'LIBERADA'}"
                                                    :disabled="analise.subsidio_sebrae_status == 'LIBERADA'"
                                                    @click="liberarAnaliseSebrae(indexAnalise)"
                                                    :title="analise.subsidio_sebrae_status == 'PENDENTE' ? 'Marcar como liberada' : 'Análise liberada'">
                                                <i class="fa fa-money-bill"></i>
                                            </button>

                                            <button v-if="consultaAnalise && gerente && analise.subsidio_sebrae == 0"
                                                    class="btn btn-xs"
                                                    :class="{'btn-success': !parseInt(analise.faturado), 'btn-danger': parseInt(analise.faturado)}"
                                                    :disabled="analise.forma_pagamento != 'NFATURAR'"
                                                    @click="pagarEstornarAnalisePrazo(indexAnalise, true)"
                                                    :title="!parseInt(analise.faturado) ? 'Receber análise' : 'Estornar analise'">
                                                <i class="fa fa-money-bill"></i>
                                            </button>

                                            <button class="btn btn-xs btn-info"
                                                    :disabled="analise.logs_analise.length == 0"
                                                    @click="abreLog(indexAnalise, false)"
                                                    title="Lista de logs"><i class="fa fa-info-circle"></i>
                                            </button>

                                            <button v-if="consultaAnalise && gerente && analise.subsidio_sebrae == 1"
                                                    class="btn btn-xs"
                                                    :class="{'btn-success': analise.solo.caminho_foto != null, 'btn-info': analise.solo.caminho_foto == null}"
                                                    :disabled="analise.solo.caminho_foto == null"
                                                    @click="downloadArquivoFoto(analise)"
                                                    :title="analise.solo.caminho_foto != null ? 'Atendimento SEBRAE anexado' : 'Sem atendimento SEBRAE'">
                                                <i class="fa fa-paperclip"></i>
                                            </button>

                                        </td>
                                    </tr>
                                    <tr v-if="celular" :class="{ 'nao-paga': !analise.faturado * 1 && analise.forma_pagamento != 'FATURADA' , 'nao-paga-boleto': analise.data_pagamento == null && analise.forma_pagamento == 'BOLETO' && analise.pedido_id != null}">
                                        <th colspan="3">
                                            <div style="margin-bottom: 7px;" v-if="analise.remetente !== null">
                                                <span v-if="analise.remetente.tipo == 1">{{ analise.remetente.nome }}<br>{{ analise.remetente.cpf }}</span>
                                                <span v-else>{{ analise.remetente.razao_social }}<br>{{ analise.remetente.cnpj }}</span>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr v-if="analise.detalhe != undefined && analise.detalhe">
                                        <vc-detalhes-analise :analise-prop="analise" @close="abreDetalhes"
                                                             :navigate="navigate"/>
                                    </tr>
                                    </tbody>
                                </table>
                                <vc-paginacao :source="paginationPendentes" @navigate="navigate"></vc-paginacao>
                            </div>
                        </div>
                    </div>

                    <div id="site" class="tab-pane fade">
                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table dataTable table-striped">
                                    <thead>
                                    <tr role="row">
                                        <th width="10%">Código</th>
                                        <th width="19%">Produtor / Proprietário</th>
                                        <th width="19%">Proprietário / Cedente</th>
                                        <th width="19%" class="text-center">Ações</th>
                                    </tr>
                                    </thead>
                                    <tbody :key="indexAnalise" v-for="(analise, indexAnalise) in analisesSite">
                                    <tr role="row" class="even">
                                        <td>{{ analise.codigo_site }}</td>
                                        <td>
                                            <div :key="index" v-for="(proprietario, index) in analise.proprietarios_site">
                                                <span>{{ proprietario.nome == null ? proprietario.fantasia : proprietario.nome }}<br>
                                                    {{ proprietario.cpf == null ? proprietario.cnpj : proprietario.cpf }}</span>
                                                <span v-if="proprietario.ie != null"><br>{{ proprietario.ie != null ? 'IE: ' + proprietario.ie : '' }}</span>
                                                <span v-if="proprietario.fone != null"><br>{{ 'Fone: ' + proprietario.fone }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div :key="index"
                                                 v-for="(arrendatario, index) in analise.arrendatarios_site"
                                                 style="margin-bottom: 7px;">
                                                <span>{{ arrendatario.nome == null ? arrendatario.fantasia : arrendatario.nome }}<br>{{ arrendatario.cpf == null ? arrendatario.cnpj : arrendatario.cpf }}</span>
                                            </div>
                                        </td>

                                        <td class="text-center lista-analises">
                                            <div v-if="consultaAnalise">
                                                <button class="btn btn-xs btn-success" v-show="analise.subsidio == 1"
                                                        title="Subsídio">
                                                    <i class="fa fa-bars"></i>
                                                </button>

                                                <button class="btn btn-xs btn-success"
                                                        @click="editarAnaliseSite(analise)"
                                                        title="Confirmar">
                                                    <i class="fa fa-check"></i>
                                                </button>

                                                <button class="btn btn-xs btn-danger" @click="remover(analise)"
                                                        title="Excluir">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </div>
                                            <p v-if="analise.observacao && analise.observacao.includes('Pago via PIX')" class="text-danger">Pago via PIX</p>
                                        </td>
                                    </tr>

                                    <tr>
                                        <vc-detalhes-analise :analise-prop="analise" @close="abreDetalhes"
                                                             :navigate="navigate"/>
                                    </tr>
                                    </tbody>
                                </table>
                                <vc-paginacao :source="paginationSite" @navigate="navigate"></vc-paginacao>
                            </div>
                        </div>
                    </div>
                    <div id="gradeExternas" class="tab-pane fade">
                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table dataTable table-hover">
                                    <thead>
                                    <tr role="row">
                                        <th width="12%" class="text-center">Data registro</th>
                                        <th width="20%">Remetente</th>
                                        <th width="15%">Responsável</th>
                                        <th width="20%">Nome do produtor</th>
                                        <th width="20%">Observações</th>
                                        <th width="10%" class="text-center">Pago</th>
                                        <th width="3%"></th>
                                    </tr>
                                    </thead>
                                    <tbody :key="indexAnalise" v-for="(analise, indexAnalise) in analisesExternas.data">
                                    <tr role="row" class="even">
                                       <td class="text-center">
                                            <span>{{ analise.data_criacao }}</span>
                                       </td>
                                       <td>
                                            <span>{{ analise.remetente.nomerazao_social}}</span>
                                       </td>
                                       <td>
                                            <span>{{ analise.responsavel_tecnico}}</span>
                                       </td>
                                       <td>
                                            <span>{{ analise.nome_produtor}}</span>
                                       </td>
                                       <td>
                                            <pre class="nl2br">{{ analise.observacoes }}</pre>
                                       </td>
                                       <td class="text-center">
                                            <span>{{ analise.confirmada == '1' ? 'Sim' : 'Não' }}</span>
                                       </td>
                                       <td>
                                            <!-- <button class="btn btn-xs btn-info" v-if="analise.confirmada == '0'"
                                                    @click="selecionarAnaliseCriarPagamento(indexAnalise)"
                                                    title="Selecionar para criar pagamento">
                                                <i class="fa" :class="analise.selecionadaPagamento != undefined && analise.selecionadaPagamento == true ? 'fa-minus' : 'fa-plus'"></i>
                                            </button> -->
                                       </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <vc-paginacao :source="paginationExternas" @navigate="navigate"></vc-paginacao>
                            </div>
                        </div>

                        <div class="row" v-if="podeCriarPagamento">
                            <div class="col-sm-12">
                                <button class="btn btn-success" @click="abrirModalCriarPagamento()">Criar pagamento</button>
                            </div>
                        </div>
                    </div>
                     <div id="gradeApp" class="tab-pane fade">
                        <div class="row">
                            <div class="col-sm-12">
                                <table class="table dataTable table-striped">
                                    <thead>
                                    <tr role="row">
                                        <th width="23%">Nome do talhão</th>
                                        <th width="22%">Remetente</th>
                                        <th width="23%">Produtor</th>
                                        <th width="22%">Propriedade</th>
                                        <th width="10%" class="text-center">Ações</th>
                                    </tr>
                                    </thead>
                                    <tbody :key="indexAnalise" v-for="(analise, indexAnalise) in analisesApp.dados">
                                    <tr role="row" class="even">
                                        <td>{{ analise.dados.talhao.nome }}</td>
                                        <td>
                                            <span>{{analise.dados.usuario.nome}}<br>{{ analise.dados.usuario.email != undefined ? analise.dados.usuario.email : ''}}</span>
                                        </td>
                                        <td>
                                            <span>{{analise.dados.produtor.nome}}<br>{{analise.dados.produtor.documento}}<br>{{ analise.dados.produtor.telefone != undefined ? analise.dados.produtor.telefone : ''}}</span>
                                        </td>
                                        <td>
                                            <span>{{analise.dados.propriedade.nome}}<br>{{analise.dados.propriedade.cidade}} - {{analise.dados.propriedade.estado}}<br>{{ analise.dados.propriedade.matricula}}</span>
                                        </td>
                                        <td class="text-center lista-analises">
                                            <button class="btn btn-xs btn-info"
                                                    @click="abrirFecharDetalhesApp(indexAnalise)"
                                                    title="Detalhes">
                                                <i class="fa" :class="analise.dados.detalhes != undefined && analise.dados.detalhes == true ? 'fa-minus' : 'fa-plus'"></i>
                                            </button>

                                            <button class="btn btn-xs btn-success" @click="aceitarApp(indexAnalise)"
                                                    title="Aceitar">
                                                <i class="fa fa-check"></i>
                                            </button>
                                            <button class="btn btn-xs btn-danger" @click="rejeitarApp(indexAnalise)"
                                                    title="Rejeitar">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    <tr v-if="analise.dados.detalhes != undefined && analise.dados.detalhes == true" v-for="(coletas, indexColeta) in analise.dados.coletas" :key="indexColeta">
                                        <td>
                                            <span>&ensp;&ensp;&ensp;Id: {{ coletas.id }}</span>
                                        </td>
                                        <td>
                                            <span>Coleta: {{ coletas.numero_da_coleta }}</span>
                                        </td>
                                        <td>
                                            <span>Profundidades: {{ coletas.profundidade.min }} / {{ coletas.profundidade.max }}</span>
                                        </td>
                                        <td colspan="2">
                                            <span>Latitude: {{ coletas.coordenadas.latitude }}<br>Longitude: {{ coletas.coordenadas.longitude }}</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div id="modal-pagamento-externas" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Pagamento de análise externa</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <div class="form-group">
                                    <label>Valor total das análises</label>
                                    <money v-model="valorAnalisesExterna" class="form-control"></money>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <div class="col-xs-12">
                            <div class="form-group">
                                <button type="button" class="btn btn-success" @click="confirmaPagamentoExterna()">Confirmar</button>
                                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal-forma-pag-aceite" class="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Confirme os dados</h4>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xs-12 col-md-3">
                                <div class="form-group">
                                    <label>Forma de pagamento</label>
                                    <v-select
                                            v-model="formaPagamentoApp"
                                            :options="[
                                            {label: 'Vista', value: 'FATURADA'},
                                            {label: 'Prazo', value: 'NFATURAR'},
                                            {label: 'Boleto', value: 'BOLETO'},
                                        ]"
                                    ></v-select>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-3">
                                <div class="form-group">
                                    <label>Análise de solo fisíca</label>
                                    <v-select
                                            v-model="fisicaApp"
                                            :options="[
                                            {label: 'Não', value: '0'},
                                            {label: 'Sim', value: '1'},
                                        ]"
                                    ></v-select>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="form-group">
                                    <label>Remetente</label>
                                    <v-select
                                            v-model="remetenteApp"
                                            :options="remetentesData"
                                            @search="buscaRemetentes()"
                                    ></v-select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <div class="col-xs-12">
                            <div class="form-group">
                                <button type="button" id="btnConfirmaResultadoApp" class="btn btn-success" @click="confirmaResultadoApp">Confirmar</button>
                                <button type="button" class="btn btn-danger" data-dismiss="modal">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    table th {
        font-size: 15px !important;
    }

    table td {
        font-size: 13px !important;
    }

    table.dataTable thead th,
    table.dataTable thead td {
        padding: 10px 18px;
        border-bottom: 1px solid #111;
    }

    @media screen and (max-width: 584px) {
        table th:nth-child(2) {
            display: none;
        }

        table td:nth-child(2) {
            display: none;
        }
    }

    @media screen and (max-width: 445px) {
        table th:nth-child(3) {
            display: none;
        }

        table td:nth-child(3) {
            display: none;
        }
    }

    @media screen and (max-width: 600px) {
        table th:nth-child(6) {
            display: none;
        }

        table td:nth-child(6) {
            display: none;
        }
    }

    @media screen and (max-width: 600px) {
        table th:nth-child(4) {
            display: none;
        }

        table td:nth-child(4) {
            display: none;
        }
    }

    @media screen and (max-width: 400px) {
        table th:nth-child(7) {
            display: none;
        }

        table td:nth-child(7) {
            display: none;
        }
    }

    .lista-analises button {
        margin-left: 5px;
    }

    .nav-tabs > li.active > a {
        font-weight: bold;
    }

    .table-striped > tbody > tr:nth-of-type(odd) {
        background-color: #ebeef2;
    }

    .nao-paga {
        background-color: #FFB2B2 !important;
    }

    .nao-paga-boleto {
        background-color: #FFFFB2 !important;
    }

    .subsidio-sebrae {
        background-color: #add7ee !important;
    }
</style>
